/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Errors_Too_LargeInputs */

const en_us2_client_errors_too_large = /** @type {(inputs: Client_Errors_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That error report was too large to send.`)
};

const pt_br2_client_errors_too_large = /** @type {(inputs: Client_Errors_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse relatório de erro ficou grande demais para enviar.`)
};

const es_419_client_errors_too_large = /** @type {(inputs: Client_Errors_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese informe de error es demasiado grande para enviarlo.`)
};

const pt_pt2_client_errors_too_large = /** @type {(inputs: Client_Errors_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse relatório de erro ficou demasiado grande para enviar.`)
};

const fr_fr2_client_errors_too_large = /** @type {(inputs: Client_Errors_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce rapport d'erreur était trop volumineux pour être envoyé.`)
};

const de_de2_client_errors_too_large = /** @type {(inputs: Client_Errors_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Fehlerbericht war zu groß zum Senden.`)
};

const it_it2_client_errors_too_large = /** @type {(inputs: Client_Errors_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo report di errore era troppo grande per essere inviato.`)
};

/**
* | output |
* | --- |
* | "That error report was too large to send." |
*
* @param {Client_Errors_Too_LargeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const client_errors_too_large = /** @type {((inputs?: Client_Errors_Too_LargeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Errors_Too_LargeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_client_errors_too_large(inputs)
	if (locale === "es-419") return es_419_client_errors_too_large(inputs)
	if (locale === "pt-PT") return pt_pt2_client_errors_too_large(inputs)
	if (locale === "fr-FR") return fr_fr2_client_errors_too_large(inputs)
	if (locale === "de-DE") return de_de2_client_errors_too_large(inputs)
	if (locale === "it-IT") return it_it2_client_errors_too_large(inputs)
	return en_us2_client_errors_too_large(inputs)
});
export { client_errors_too_large as "client_errors.too_large" }